<template>
  <el-dialog
    :title="ruleForm.id ? '更新站点' : '添加站点'"
    :visible.sync="visible"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <el-form-item label="站点名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="域名列表" prop="domainList">
        <el-input
          type="textarea"
          v-model="ruleForm.domainList"
          :autosize="{ minRows: 4, maxRows: 6 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="仅展示" prop="onlyShowDomainList">
        <el-select
          v-model="ruleForm.onlyShowDomainList"
          multiple
          placeholder="不选，则默认显示全部域名的数据"
          style="width: 100%"
          clearable
        >
          <el-option
            v-for="item in domainListArray"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <div>
          如果想查看特定域名的数据，请勾选相应域名，为空则表示查看所有数据。
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-input v-model="ruleForm.comment"></el-input>
      </el-form-item>
      <el-form-item label="启用站点" prop="state">
        <el-switch
          v-model="ruleForm.state"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import request from '@/utils/request.js'
import { uniq } from 'lodash'
const defaultFrom = {
  name: '',
  domainList: '', // 域名列表
  onlyShowDomainList: [],
  comment: '', // 备注 - 可选
  state: 1 // 站点状态，0 代表停用，1 代表启用
}
export default {
  props: {
    siteAddVisible: Boolean,
    siteActive: Object
  },
  data () {
    let ruleForm = { ...defaultFrom }
    ruleForm.onlyShowDomainList = this.getStorageOnlyShowList()
    return {
      visible: this.siteAddVisible,
      ruleForm,
      rules: {
        name: [{ required: true, message: '请输入站点名称', trigger: 'blur' }],
        domainList: [
          { required: true, message: '请输入域名列表', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    domainListArray () {
      let arr = this.ruleForm.domainList
        .split(/[\r\n]/)
        .filter((val) => val.trim().length > 0)
      let list = this.getStorageOnlyShowList()
      if (Array.isArray(list) && list.length > 0) {
        arr = arr.concat(list)
      }
      return uniq(arr)
    }
  },
  mounted () {
    let siteId = _.get(this.siteActive, 'id')
    if (siteId) {
      this.ruleForm.id = siteId
      for (const i in this.siteActive) {
        if (this.ruleForm[i] !== undefined) {
          this.ruleForm[i] = this.siteActive[i]
        }
      }
      this.ruleForm.state = this.siteActive.state
      this.ruleForm.domainList = this.ruleForm.domainList.join('\r\n')
    }
  },
  methods: {
    async handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          request.post('/site/submit', this.ruleForm).then(() => {
            this.$message({
              message: this.ruleForm.id ? '更新站点成功' : '添加站点成功',
              type: 'success',
              duration: 2000
            })
            setTimeout(() => {
              location.reload()
            }, 500)
            this.handleClose()
            this.$store.dispatch('getUserInfo')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.$emit('update:siteAddVisible', false)
      this.$emit('update')
    },
    // 获取extra_json中的“仅展示”的配置信息
    getStorageOnlyShowList () {
      let siteId = _.get(this.siteActive, 'id')
      if (!siteId) {
        return []
      }
      let arr = _.get(
        this.$store.state.userInfo,
        `extra_json.onlyShowDomainMap[${siteId}]`
      )
      if (Array.isArray(arr)) {
        return arr
      }
      return []
    }
  }
}
</script>
